import { PropertyTileDefinition } from './types.js';

export const tkv2ReferenceViewIDAttr = 'data-v2-ref-id';
export const tkv2ReferenceMapPinLabelAttr = 'data-v2-ref-map';

export const propertySectionTiles: PropertyTileDefinition[] = [
  {
    id: 'listing_record',
    label: 'Listing Record',
    icon: 'mls-listing',
    dataSheet: 'mls-listing',
  },
  { id: 'listing_photos', label: 'Listing Photos', icon: 'image', dataSheet: 'mls-images' },

  {
    id: 'public_record',
    label: 'Public Record',
    icon: 'bank',
    dataSheet: 'public-record',
  },
  {
    id: 'street_view',
    label: 'Street View',
    icon: 'street-view',
    dataSheet: 'mls-street-view',
  },
];
